export const getJsonObject = (content: string): any => {
  let contentObj = null;

  // Check if content is JSON
  try {
    contentObj = JSON.parse(content);
  } catch (e) {}
  return contentObj;
};

export const isJsonString = (object: string) => {
  return getJsonObject(object) !== null;
};
